let utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'master-supplier-edit',
  created () {
    this.getSupplier()
  },
  data () {
    return {
      canValidate: true,
      supplier: {
        name: '',
        name_hurigana: '',
        responsible_name: '',
        tel_no: '',
        fax_no: '',
        mail: '',
        postal_code: '',
        address: '',
        order_method: '',
        fee_type: 'no_fee'
      },
      isSaving: false,
      searchCallbackFlag: false
    }
  },
  computed: {
    validation () {
      let hiragana = /^[\u3040-\u309fー]+$/
      let tel = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      let email = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

      let validation = {
        name: !!this.supplier.name,
        name_hurigana: !!this.supplier.name_hurigana && hiragana.test(this.supplier.name_hurigana),
        responsible_name: !!this.supplier.responsible_name,
        tel_no: !!this.supplier.tel_no && tel.test(this.supplier.tel_no),
        fax_no: this.supplier.order_method !== 'fax' || (tel.test(this.supplier.fax_no) || !!this.supplier.fax_no),
        mail: this.supplier.order_method !== 'email' || (!!this.supplier.mail && email.test(this.supplier.mail)),
        postal_code: !!this.supplier.postal_code,
        address: !!this.supplier.address,
        order_method: !!this.supplier.order_method,
        fee_type: !!this.supplier.fee_type
      }
      if (!this.canValidate) {
        Object.keys(validation).forEach(
          key => {
            validation[key] = true
          }
        )
      }
      return validation
    },
    validationAll () {
      if (!this.validation.name) return false
      if (!this.validation.name_hurigana) return false
      if (!this.validation.responsible_name) return false
      if (!this.validation.tel_no) return false
      if (!this.validation.mail) return false
      if (!this.validation.postal_code) return false
      if (!this.validation.address) return false
      if (!this.validation.order_method) return false
      return true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getSupplier () {
      let res = await this.$store.dispatch('GET_SUPPLIER', {id: this.$route.params.id})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.supplier = res.supplier
      this.searchCallbackFlag = true
    },
    async onChangePostNo () {
      if (this.supplier.postal_code) {
        this.supplier.postal_code = this.supplier.postal_code.replace(/-/g, '')
      }

      if (!!this.supplier.postal_code && utils.regex.post_no.test(this.supplier.postal_code)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.supplier.postal_code,
          callback: (addr) => {
            if (addr) {
              this.supplier.address = addr.address1 + addr.address2
              if (!utils.isBlank(this.supplier.address)) {
                this.supplier.address = utils.emHalf(this.supplier.address)
              }

              let arr = []
              if (utils.isPresent(this.supplier.postal_code)) {
                arr.push(this.supplier.postal_code)
              }
              if (utils.isPresent(this.supplier.address)) {
                arr.push(this.supplier.address)
              }

              if (arr.length > 0) {
                let address = arr.join(' ')
                if (window.googleMapsQuerySearch) {
                  window.googleMapsQuerySearch(address)
                }
              }
            }
          }
        })
      }
    },
    async onClickSave () {
      // 連打対応
      if (this.isSaving) return false
      this.isSaving = true
      // 保存処理
      await this.$store.dispatch('UPDATE_MASTER_SUPPLIER', {
        data: {
          id: this.$route.params.id,
          name: this.supplier.name,
          name_hurigana: this.supplier.name_hurigana,
          responsible_name: this.supplier.responsible_name,
          tel_no: this.supplier.tel_no,
          fax_no: this.supplier.fax_no,
          mail: this.supplier.mail,
          postal_code: this.supplier.postal_code,
          address: this.supplier.address,
          order_method: this.supplier.order_method,
          fee_type: this.supplier.fee_type
        }
      })
      .catch(err => {
        console.error(err)
        return
      })

      // サプライヤー一覧へ戻る
      this.$router.push('/master_supplier_list')
    },
    onClickCancel () {
      this.$router.push('/master_supplier_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-supplier-edit.js